module.exports = __webpack_public_path__ + "static/Nahe1-scaled-580c83ebc3c28264334f99a8aa01ccdd.jpeg";